/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Location = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.6089 13.3474C11.3224 13.2241 12.0221 13.6281 12.2721 14.3077L14.4102 20.1205L17.4001 3.50518L4.50573 14.4022L10.6089 13.3474ZM4.76119 15.8803C3.25435 16.1407 2.36956 14.2436 3.53752 13.2565L16.4319 2.35951C17.5055 1.4522 19.1253 2.38741 18.8764 3.77084L15.8865 20.3862C15.6156 21.8912 13.5303 22.0735 13.0024 20.6384L10.8643 14.8255L4.76119 15.8803Z"
                        fill={color}
                    />
                </svg>
        );
    };
